import React from 'react'
import ClubMembersBody from '../../../components/AdminDashboard/ClubMembers/ClubMembersBody'
import SideNav from '../../../layouts/AdminDashboard/SideNav'

const ClubMembers = () => {
    return (
        <div className='flex justify-end mobile:justify-start mobile:w-screen mobile:flex-col min-h-screen w-full mobile:bg-[#E5E5E5]'>
            
            {/* Side nav */}
            <SideNav />

            {/* Setting Body */}
            <ClubMembersBody />

        </div>
    )
}

export default ClubMembers